<template>
	<v-dialog :value="open" persistent width="auto">
		<v-card class="loading-card" v-if="loading || errorMessage">
			<v-alert type="error" v-if="errorMessage">{{ errorMessage }}</v-alert>
			<v-progress-circular class="loading" indeterminate v-else></v-progress-circular>
		</v-card>
		<v-card class="dialog account-picker-dialog" v-else>
			<v-card-title>You have multiple accounts to choose from</v-card-title>

			<v-card-text>
				<div v-for="account in accounts" :key="account.id" class="account-option">
					<v-btn x-large class="org-picker" @click="pickAccount(account)">
						<div class="logo" v-if="account.organization.parent_organization?.logo_thumb_url"><img :src="account.organization.parent_organization.logo_thumb_url" /></div>
						<div class="logo" v-else-if="account.organization.logo_thumb_url"><img :src="account.organization.logo_thumb_url" /></div>

						<div class="name-labels">
							<div>{{ account.organization.name }}</div>
							<div v-if="account.organization.parent_organization">{{ account.organization.parent_organization.name }}</div>
						</div>
					</v-btn>
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import getAccountsFromMe from '../management/get-accounts-from-me';
import { client, plicAxios } from '../utils/axios';
export default {
	props: ['open', 'plicSlug', 'redirectUrl'],
	data: () => ({
		loading: true,
		errorMessage: null,
		accounts: []
	}),
	watch: {
		open() {
			if(this.open) {
				this.load();
			}
		}
	},
	methods: {
		async load() {
			this.loading = true;
			try {
				let response = await plicAxios.get('users/me?include_accounts=true');
				let meData = response.data;

				this.accounts = getAccountsFromMe(meData, {
					filterBySlug: this.plicSlug
				});
				if(this.accounts.length <= 1) {
					window.location = this.redirectUrl;
					return;
				} else if(this.$route?.query?.account_id) {
					let pickedAccount = this.accounts.find(account => account.id === this.$route.query.account_id);
					if(pickedAccount) {
						this.pickAccount(pickedAccount);
						return;
					}
				}
			} catch(error) {
				let errorMessage = this.i18n('misc.errorLoading');
				if(error.response?.data?.reason) {
					errorMessage = error.response.data.reason;
				}
				this.errorMessage = errorMessage;
			}
			this.loading = false;
		},
		pickAccount(account) {
			this.loading = true;

			// This should already be what we have selected
			if(account.currentAccount) {
				window.location = this.redirectUrl;
			} else {
				client.post('/ajax/switchAccount.php', {
					accountId: account.id
				}).then(response => {
					if(response.data.url) {
						window.location = response.data.url;
					} else {
						window.location = this.redirectUrl;
					}
				}).catch(error => {
					this.loading = false;
					let errorMessage = this.i18n('misc.errorLoading');
					if(error.response?.data?.reason) {
						errorMessage = error.response.data.reason;
					}
					this.$emit('error', errorMessage);
				});
			}
		}
	}
};
</script>

<style scoped>
.loading-card {
	min-height: 10em;
	min-width: 10em;

	display: flex;
	align-items: center;
	justify-content: center;
}

.org-picker {
	margin-top: 1em;
	width: 100%;
}
.org-picker:deep(.v-btn__content) {
	justify-content: start;
}

.logo {
	height: 100%;
	margin-right: 1em;
}
.logo img {
	width: 40px;
	height: 40px;
}

.name-labels {
	text-align: start;

	font-size: 1.22857143rem;
}
</style>